const discountTypeEnum = {
  showOrdinaryPrice: 'original',
  showDiscount: 'discount',
  dontShow: 'hide',
};

export default discountTypeEnum;
